import Vue from 'vue'
import Router from 'vue-router'
import Games from '@/pages/Games/index.vue'
import Share from '@/pages/Share/index.vue'
import Promotion from '@/pages/Promotion/index.vue'
import Setting from '@/pages/Setting/index.vue'
import Account from '@/pages/Account/index.vue'
import History from '@/pages/History/index.vue'
import Message from '@/pages/Message/index.vue'
import Edit from '@/pages/Edit/index.vue'
import FAQ from '@/pages/FAQ/index.vue'
import Documents from '@/pages/Documents/index.vue'
import Terms from '@/pages/Documents/Terms.vue'
import Privacy from '@/pages/Documents/Privacy.vue'
import Responsible from '@/pages/Documents/Responsible.vue'
import About from '@/pages/Documents/About.vue'
import News from '@/pages/Documents/News.vue'
import LandingTemplate1 from '@/pages/Landing/template1.vue'
import LandingTemplate2 from '@/pages/Landing/template2.vue'
import Kyc from '@/pages/Documents/KycPolicy.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/Home',
      name: 'Home',
      component: Games,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/Games',
      name: 'Games',
      component: Games,
      meta: {
        keepAlive: true,
        hideTopBg: true
      }
    },
    {
      path: '/Share',
      name: 'Share',
      component: Share,
      meta: {
        keepAlive: false,
        hideTopBg: false
      }
    },
    {
      path: '/Promotion',
      name: 'Promotion',
      component: Promotion,
      meta: {
        keepAlive: true,
        hideFooter: true,
        title: 'Exclusive Casino & Betting Promotions in India PGEBet',
        description: '🔥 Exclusive Casino & Sports Betting Offers at PGEBet! Grab 100% Deposit Bonuses, Free Bets, Cashback & IPL Specials. Limited Time Only – T&C Apply!',
        keywords: 'Casino Bonuses India,Sports Betting Offers,IPL Betting Promotions.'
      }

    },
    {
      path: '/Setting',
      redirect: '/Setting/Account',
      name: 'Setting',
      component: Setting,
      children: [
        {
          path: 'Account',
          name: 'Account',
          component: Account,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        },
        {
          path: 'Deposit',
          name: 'Deposit',
          component: Account,
          meta: {
            keepAlive: true,
            hideBottomBg: true,
            title: 'Secure Deposit Methods for Online Casino & Betting PGEBet',
            description: 'Easy and Secure Deposit Options at PGEBet',
            keywords: 'How toDeposit Money,"Supported Payment Methods","Instant Deposit Guide"'
          }
        },
        {
          path: 'Withdraw',
          name: 'Withdraw',
          component: Account,
          meta: {
            keepAlive: true,
            hideBottomBg: true,
            title: 'Fast Withdrawal Methods for Casino & Betting PGEBet',
            description: 'Quick and Hassle-Free Withdrawals at PGEBet',
            keywords: 'How to Withdraw Your Winnings, "Withdrawal Timeframes", "Secure Transactions" '
          }
        },
        {
          path: 'Verify',
          name: 'Verify',
          component: Account,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        },
        {
          path: 'History',
          name: 'History',
          component: History,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        },
        {
          path: 'Message',
          name: 'Message',
          component: Message,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        },
        {
          path: 'Edit',
          name: 'Edit',
          component: Edit,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        }
      ]
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: FAQ,
      meta: {
        keepAlive: true,
        hideBottomBg: true
      }
    },
    {
      path: '/Documents',
      redirect: '/Documents/Terms',
      name: 'Documents',
      component: Documents,
      children: [
        {
          path: 'Terms',
          name: 'Terms',
          component: Terms,
          meta: {
            keepAlive: true,
            hideBottomBg: true,
            title: 'Terms and Conditions for Online Casino & Betting PGEBet',
            description: 'PGEBet Terms & Conditions 📜: Fair Play, Bonus Rules & Legal Policies for Online Casino & Sports Betting in India. Read Before You Play!',
            keywords: 'Casino T&C India,Betting Rules,Legal Online Gambling India.'
          }
        },
        {
          path: 'Privacy',
          name: 'Privacy',
          component: Privacy,
          meta: {
            keepAlive: true,
            hideBottomBg: true,
            title: 'Privacy Policy for Online Casino & Betting PGEBet',
            description: 'Your Privacy Matters at PGEBet',
            keywords: 'Data Collection and Usage,How We Protect Your Information, Your Rights'
          }
        },
        {
          path: 'Responsible',
          name: 'Responsible',
          component: Responsible,
          meta: {
            keepAlive: true,
            hideBottomBg: true,
            description: 'Play Responsibly at PGEBet 🛡️: Set Deposit Limits, Self-Exclusion & Get Support. Enjoy Safe Casino Games & Sports Betting in India. We Care!',
            keywords: 'Responsible Gambling India,Safe Betting Site,Casino Deposit Limits'
          }
        },
        {
          path: 'About',
          name: 'About',
          component: About,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        },
        {
          path: 'News',
          name: 'News',
          component: News,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        },
        {
          path: 'Kyc',
          name: 'Kyc',
          component: Kyc,
          meta: {
            keepAlive: true,
            hideBottomBg: true
          }
        }
      ]
    },
    {
      path: '/Landing1',
      name: 'Landing1',
      component: LandingTemplate1,
      meta: {
        keepAlive: true,
        hideTopBar: true,
        hideFooter: true,
        showWinner: false
      }
    },
    {
      path: '/Landing2',
      name: 'Landing2',
      component: LandingTemplate1,
      meta: {
        keepAlive: true,
        hideTopBar: true,
        hideFooter: true,
        showWinner: false
      }
    },
    {
      path: '/Landing3',
      name: 'Landing3',
      component: LandingTemplate2,
      meta: {
        keepAlive: true,
        hideTopBar: true,
        hideFooter: true,
        showWinner: false
      }
    },
    {
      path: '/Landing4',
      name: 'Landing4',
      component: LandingTemplate1,
      meta: {
        keepAlive: true,
        hideTopBar: true,
        hideFooter: true,
        showWinner: false
      }
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js